import { Flex } from '@fivehealth/botero';

const TableCellWrapper = (props) => <Flex {...props} />;
export default TableCellWrapper;
